import CustomHookFactory from "./CustomHookFactory";

export default CustomHookFactory("Snackbar", {
  isOpen: false,
  message: "",
  type: undefined,
  additionalComponent: false,
  additionalComponentMethod: () => {}
});
